<template>
  <div class="payment-window-component">
    <div class="tabs d-flex justify-space-between">
      <button
        :class="{ active: currentPaymentTab === 'paymentTypes' }"
        class="tab"
      >
        Типы оплаты
      </button>
      <button :class="{ active: currentPaymentTab === 'paid' }" class="tab">
        Оплачено
      </button>
    </div>

    <template v-if="currentPaymentTab === 'paymentTypes'">
      <h1 class="step-title font-weight-regular">
        Укажите тип оплаты:
      </h1>
      <div class="button-group d-flex justify-between">
        <v-row dense class="justify-space-between">
          <v-col sm="5">
            <v-btn
              class="button button-back"
              width="100%"
              color="#F1F3F6"
              @click="stepBack"
            >
              <font-awesome-icon icon="chevron-left" />
              Вернуться назад
            </v-btn>
          </v-col>
          <v-col sm="5">
            <v-btn
              class="button button-apply"
              width="100%"
              color="#F1F3F6"
              :disabled="paymentChangeDisabled"
              @click="changePayment"
            >
              <font-awesome-icon icon="check" />
              Подтвердить Тип оплаты
            </v-btn>
          </v-col>
        </v-row>
      </div>

      <div
        v-if="paymentChangeDisabled"
        class="payment-locked-note"
      >
        {{ paymentChangeDisabledReason }}
      </div>

      <div class="pay-types-section">
        <v-row dense class="justify-space-between">
          <v-col sm="5">
            <v-btn-toggle
              v-model="currentPayType"
              dense
              group
              mandatory
              class="d-block"
            >
              <v-btn
                v-if="showTerminalButton"
                value="terminal"
                class="button button-pay-type"
                block
                :disabled="paymentChangeDisabled"
              >
                {{ terminalPaymentLabel }}
              </v-btn>
              <template v-if="isSourceAggregator">
                <v-btn
                  value="aggregator_online"
                  class="button button-pay-type"
                  block
                  :disabled="paymentChangeDisabled"
                >
                  Оплачен онлайн в
                  <template v-if="isSourceDeliveryClub">
                    &nbsp;"Delivery Club"
                  </template>
                  <template v-else-if="isSourceYandex">
                    &nbsp;"Яндекс.Еда"
                  </template>
                </v-btn>
              </template>

              <template v-else>
                <v-btn
                  v-if="showCashButton"
                  value="cash"
                  class="button button-pay-type"
                  block
                  :disabled="paymentChangeDisabled"
                >
                  {{ cashPaymentLabel }}
                </v-btn>
                <!--                <v-btn value="online" class="button button-pay-type" block dark>
                  Предоплата
                </v-btn>-->
              </template>
            </v-btn-toggle>
          </v-col>

          <v-col sm="5">
            <sliding-switch
              v-if="showPaymentModes"
              v-model="paymentMode"
              :items="paymentModeItems"
              class="payment-modes"
            />
            <div v-if="showPaymentModes && disabledModeHint" class="payment-modes-hint">
              <font-awesome-icon icon="info-circle" />
              {{ disabledModeHint }}
            </div>

            <!--            <div v-if="currentPayType === 'terminal'" class="card-section">
              <payment-type-icons />
            </div>-->

            <div v-if="showCashCalculator" class="cash-section">
              <span
                class="d-block label"
              >С какой суммы подготовить сдачу?</span>
              <cash-calculator v-model="amount" hide-increment-decrement />
              <!-- <v-row class="amount-field">
                <v-col sm="6">
                  <v-text-field
                    v-model.number="amount"
                    hide-details="auto"
                    class="text-field"
                    type="number"
                    flat
                    solo
                    @keydown="clearAmountCount"
                  />
                </v-col>
                <v-col sm="6">
                  <v-btn class="button button-clear" block @click="clearAmount">
                    <font-awesome-icon icon="times" />
                    Очистить
                  </v-btn>
                </v-col>
              </v-row>
              <v-row class="suggestions">
                <v-col v-for="(item, i) in amounts" :key="i" sm="6">
                  <v-badge
                    class="fullwidth"
                    :content="item.count"
                    :color="item.count ? '#ff9100' : 'transparent'"
                  >
                    <v-btn class="button" block @click="setAmount(item.amount)">
                      {{ item.amount }}₽
                    </v-btn>
                  </v-badge>
                </v-col>
              </v-row> -->
            </div>
          </v-col>
        </v-row>
      </div>
    </template>

    <template v-if="currentPaymentTab === 'paid'">
      <h1 class="step-title font-weight-regular"></h1>

      <div class="button-group d-flex justify-between">
        <v-row v-if="false" dense class="justify-space-between">
          <v-col sm="5">
            <v-btn
              class="button button-back"
              width="100%"
              color="#F1F3F6"
              @click="stepBack"
            >
              <font-awesome-icon icon="chevron-left" />
              Вернуться назад
            </v-btn>
          </v-col>
          <!--          <v-col sm="5">
            <v-btn class="button button-apply" width="100%" color="#F1F3F6">
              <font-awesome-icon icon="check" />
              Сохранить адрес
            </v-btn>
          </v-col>-->
        </v-row>
        <v-col md="6" offset-md="3">
          <div class="paid-section">
            <div class="order-code">
              Заказ № {{ order.code }}
            </div>
            <div class="date">
              {{ paidOrderDateText }}
            </div>
            <div class="paid-status">
              Оплачено
            </div>
            <!-- Колл-центр оплаченный заказ не отменяет (правило колл-центра на бэке), а API платежей ему закрыт crm.make-order-payment - кнопку не показываем -->
            <div v-if="!isCallCenterUser" class="actions">
              <v-tooltip top max-width="300" :disabled="!cancelRestriction">
                <template v-slot:activator="{ on, attrs }">
                  <span class="d-inline-block" v-bind="attrs" v-on="on">
                    <v-btn
                      color="red"
                      class="button font-weight-medium"
                      :dark="!cancelRestriction"
                      :disabled="!!cancelRestriction"
                      @click="showCancelDialog = true"
                    >
                      <font-awesome-icon icon="times" />
                      Отменить заказ и оплату
                    </v-btn>
                  </span>
                </template>
                {{ cancelRestriction }}
              </v-tooltip>
            </div>

            <!--            <div class="pay-desc text-center">
              <p>При отмене заказа, клиенту вернутся денежные средства!</p>
              <p>
                Возврат денег обычно занимает от нескольких минут до нескольких
                часов в зависимости от Банка
              </p>
            </div>-->
          </div>
        </v-col>
        <v-row> </v-row>
      </div>
    </template>

    <cancel-order-dialog
      v-model="showCancelDialog"
      :order="order"
      :loading="canceling"
      @cancel="cancelOrder"
      @canceled="onOrderCanceled"
    />
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import PickupPoint from '@/components/order-processing/order-components/second-step/PickupPoint'
  import VKeyboard from '@/components/order-processing/new-order/keyboard/Keyboard'
  import IconApplePay from '@/components/icons/payment-systems/IconApplePay'
  import IconGoogle from '@/components/icons/payment-systems/IconGoogle'
  import IconMaestro from '@/components/icons/payment-systems/IconMaestro'
  import IconMastercard from '@/components/icons/payment-systems/IconMastercard'
  import IconMir from '@/components/icons/payment-systems/IconMir'
  import IconVisa from '@/components/icons/payment-systems/IconVisa'
  import mixinSnackbarMessage from '@/mixins/snackbar-message'
  import PaymentType from '@/models/enums/PaymentType'
  import PaymentMode from '@/models/enums/PaymentMode'
  import CRMPermission from '@/models/enums/permissions/CRMPermission'
  import {
    availablePaymentModes,
    acceptedPaymentTypes,
    enabledPaymentModes,
    paymentModeItems,
    disabledModeHint,
  } from '@/util/payment-mode'
  import SlidingSwitch from '@/components/ui/buttons/SlidingSwitch.vue'
  import PaymentTypeIcons from '@/components/order-processing/order-components/payment/PaymentTypeIcons.vue'
  import CashCalculator from './CashCalculator.vue'
  import { formatIsoDateTimeAsDateTime } from '@/util/date-time-helper'
  import { cancelRestrictionReason } from '@/util/order-cancel'
  import CancelOrderDialog from '@/components/order-processing/order-components/CancelOrderDialog.vue'

  export default {
    name: 'EditPaymentWindow',
    components: {
      SlidingSwitch,
      CancelOrderDialog,
      PaymentTypeIcons,
      PickupPoint,
      VKeyboard,
      IconApplePay,
      IconGoogle,
      IconMaestro,
      IconMastercard,
      IconMir,
      IconVisa,
      CashCalculator,
    },
    mixins: [mixinSnackbarMessage],
    data () {
      return {
        paymentIcons: [
          'IconApplePay',
          'IconGoogle',
          'IconMaestro',
          'IconMastercard',
          'IconMir',
          'IconVisa',
        ],
        amounts: [
          { amount: 5000, count: 0 },
          { amount: 2000, count: 0 },
          { amount: 1000, count: 0 },
          { amount: 500, count: 0 },
          { amount: 100, count: 0 },
        ],
        showAddressForm: false,
        currentPayType: 'card',
        amount: 0,
        currentPaymentTab: 'paymentTypes',
        paymentMode: null,
        showCancelDialog: false,
        canceling: false,
      }
    },
    computed: {
      ...mapState({
        // currentPaymentTab: (state) => state.newOrder.currentPaymentTab,
        client: (state) => state.clients.clientsSingle,
        basket: (state) => state.baskets.basket,
        order: (state) => state.orders.currentEditOrder,
      }),
      ...mapGetters({
        isSourceAggregator: 'baskets/isSourceAggregator',
        isSourceYandex: 'baskets/isSourceYandex',
        isSourceDeliveryClub: 'baskets/isSourceDeliveryClub',
        isCallCenterUser: 'auth/isCallCenterUser',
        orderCancelFlags: 'auth/orderCancelFlags',
      }),
      payment () {
        if (this.order && this.order.payment) {
          return this.order.payment
        }
        return {}
      },
      isPaidSuccess () {
        return this.payment.status === 'success'
      },
      cancelRestriction () {
        return cancelRestrictionReason(this.order, this.orderCancelFlags)
      },
      // бэк для CRM добавил к доставке методы точки; оставляем те, что принимают хотя бы в одном доступном режиме
      availableTypes () {
        return acceptedPaymentTypes(this.basket, this.availablePaymentModes)
      },
      cashPaymentAvailable () {
        return this.availableTypes.includes(PaymentType.Cash)
      },
      terminalPaymentAvailable () {
        return this.availableTypes.includes(PaymentType.Terminal)
      },
      // текущий тип заказа показываем всегда; набор с бэка пустой = настройка не задана, ведём себя как раньше
      showCashButton () {
        return !this.basket?.availablePaymentTypes?.length ||
          this.cashPaymentAvailable ||
          this.basket.paymentType === PaymentType.Cash
      },
      showTerminalButton () {
        return !this.basket?.availablePaymentTypes?.length ||
          this.terminalPaymentAvailable ||
          this.basket.paymentType === PaymentType.Terminal
      },
      isOnlinePaymentOrder () {
        return this.basket.paymentType === PaymentType.Online ||
          this.basket.paymentType === PaymentType.AggregatorOnline ||
          this.isSourceAggregator
      },
      paymentChangeDisabled () {
        return this.isPaidSuccess || this.isOnlinePaymentOrder
      },
      availablePaymentModes () {
        return availablePaymentModes({
          deliveryType: this.basket.deliveryType,
          canPayNow: this.userCan(CRMPermission.MakeOrderPayment),
          isCallCenter: this.isCallCenterUser,
        })
      },
      enabledPaymentModes () {
        return enabledPaymentModes(this.basket, this.availablePaymentModes, this.currentPayType)
      },
      paymentModeItems () {
        return paymentModeItems(this.basket, this.availablePaymentModes, this.currentPayType)
      },
      disabledModeHint () {
        return disabledModeHint(this.basket, this.availablePaymentModes, this.currentPayType)
      },
      // режим доступен и заказам с сайта/приложения: у них он не сохранён (null = по типу доставки),
      // оператор может уточнить; для онлайн его ставит бэк; одна позиция - выбирать нечего
      showPaymentModes () {
        return !this.paymentChangeDisabled &&
          this.currentPayType !== PaymentType.Online &&
          this.availablePaymentModes.length > 1
      },
      // при «оплата позже» денег сейчас не берут - сдачу считать нечего
      showCashCalculator () {
        return this.currentPayType === PaymentType.Cash && this.paymentMode !== PaymentMode.PayLater
      },
      paymentChangeDisabledReason () {
        return this.isPaidSuccess
          ? 'Заказ уже оплачен - смена типа оплаты недоступна'
          : 'Заказ с онлайн-оплатой - смена типа оплаты недоступна'
      },
      terminalPaymentLabel () {
        return PaymentType.getPickLabel(PaymentType.Terminal, this.basket.deliveryType)
      },
      cashPaymentLabel () {
        return PaymentType.getPickLabel(PaymentType.Cash, this.basket.deliveryType)
      },
      paidOrderDateText () {
        return `от ${formatIsoDateTimeAsDateTime(this.order.createdAt)}`
      },
    },
    watch: {
      enabledPaymentModes (modes) {
        if (!modes.includes(this.paymentMode)) {
          this.paymentMode = modes[0] || this.availablePaymentModes[0]
        }
      },
    },
    mounted () {
      this.amount = this.basket.clientMoney || 0
      this.currentPayType = this.basket.paymentType || 'card'
      this.paymentMode = this.enabledPaymentModes.includes(this.order?.paymentMode)
        ? this.order.paymentMode
        : this.enabledPaymentModes[0] || this.availablePaymentModes[0]
      if (this.isPaidSuccess) {
        this.currentPaymentTab = 'paid'
      }
    },
    methods: {
      changePayment () {
        if (this.paymentChangeDisabled) {
          this.showErrorMessage(this.paymentChangeDisabledReason)
          return
        }

        const data = {}
        const id = this.basket.id

        switch (this.currentPayType) {
          case PaymentType.Cash:
            data.paymentType = PaymentType.Cash
            data.clientMoney = this.amount
            break

          default:
            data.paymentType = this.currentPayType
        }

        if (this.showPaymentModes) {
          data.paymentMode = this.paymentMode
        }

        this.$store
          .dispatch('baskets/updateBasketPayment', { data, id })
          .then((res) => {
            if (res.status === 200) {
              this.showSuccessMessage('Тип оплаты обновлен')
              // диалог оплаты после закрытия формы - только если режим реально сменили на «оплатить сейчас»
              if (data.paymentMode && data.paymentMode !== this.order?.paymentMode) {
                this.$store.commit('fastOrder/setPayNowSelected', data.paymentMode === PaymentMode.PayNow)
              }
              this.$store.dispatch('baskets/fetchSingleBasket', this.basket.id)
              // режим уходит в платёж - карточке нужен свежий paymentMode
              this.$store.dispatch('orders/refreshCurrentOrder', this.order.id)
            } else {
              this.showErrorMessage(res.response.data.message)
            }
          })
      },
      setAmount (amount) {
        this.$nextTick(() => {
          if (this.amount) {
            this.amount = parseInt(this.amount)
          }
          this.amount += parseInt(amount)
          const currentAmount = this.amounts.find(
            (item) => item.amount === amount,
          )
          currentAmount.count++
        })
      },
      clearAmount () {
        this.amount = 0
        this.$nextTick(() => {
          this.amount = 0
          this.clearAmountCount()
        })
      },
      clearAmountCount () {
        this.amounts.forEach((item) => {
          item.count = 0
        })
      },
      stepBack () {
        this.$store.commit('fastOrder/setStep', 1)
      },
      setTab (tab) {
        this.currentTab = tab
      },
      cancelOrder () {
        this.canceling = true
        this.$store
          .dispatch('orders/cancelOrder', this.order.id)
          .then((res) => {
            if (res.status === 200) {
              this.showCancelDialog = false
              this.showSuccessMessage('Заказ № ' + this.order.code + ' отменён!')
              this.$router.push('/orders')
            } else {
              this.showErrorMessage(res.response.data.message)
            }
          })
          .catch((e) => {
            this.showErrorFromResponse(e)
          })
          .finally(() => {
            this.canceling = false
          })
      },
      onOrderCanceled ({ orderCanceled }) {
        if (!orderCanceled) {
          // платёж возвращён, заказ жив: обновляем заказ, иначе кнопка снова предложит возврат
          this.$store.dispatch('orders/refreshCurrentOrder', this.order.id)
          return
        }
        this.showSuccessMessage('Заказ № ' + this.order.code + ' отменён!')
        this.$router.push('/orders')
      },
    },
  }
</script>

<style lang="less" scoped>
.payment-window-component {
  padding-top: 30px;
  background-color: #fafafa;

  .tabs {
    margin-bottom: 33px;
    border-bottom: 1px solid #d4d4d4;

    .tab {
      flex: 1;
      outline: none;
      font-size: 24px;
      line-height: 21px;
      border-radius: 14px 14px 0 0;
      height: 57px;
      cursor: default;

      &.active {
        background-color: #191919;
        font-weight: 900;
        color: @color-primary;
      }
    }
  }

  .button {
    height: 80px;
    box-shadow: 0 3px 6px #00000029 !important;
    background-color: @color-secondary !important;
    border-radius: 10px !important;
    font-size: 15px;
    line-height: 20px;
    color: #000000;
    font-weight: 500;
  }

  .text-field {
    &.v-input--is-focused {
      ::v-deep {
        .v-input__slot {
          border: 2px solid #ff9500;
        }
      }
    }

    &.error--text {
      ::v-deep {
        .v-input__slot {
          border: 2px solid @color-error;
        }
      }
    }

    ::v-deep {
      .v-input__slot {
        height: 80px;
        background-color: @color-secondary;
        border-radius: 15px;

        input {
          font-size: 25px;
          line-height: 18px;
        }
      }
    }
  }

  .step-title {
    font-size: 34px;
    line-height: 21px;
    margin-bottom: 33px;
  }

  .button-group {
    margin-bottom: 21px;

    .button {
      height: 80px;
      font-size: 15px;
      box-shadow: 0 3px 6px #00000029 !important;

      svg {
        margin-right: 8px;
      }
    }

    .button-back {
      border-radius: 10px;
      svg {
        .fill-svg(#0033ff);
      }
    }

    .button-apply {
      background-color: @color-success !important;
      color: #ffffff;
      border-radius: 10px;

      svg {
        .fill-svg(#ffffff);
      }
    }
  }

  .payment-locked-note {
    margin-bottom: 21px;
    padding: 16px 20px;
    background-color: #fff4e0;
    border-radius: 10px;
    font-size: 18px;
  }

  .pay-types-section {
    .payment-icons {
      .payment-icon {
        margin-top: 13px;
        margin-bottom: 15px;
        margin-right: 30px;
      }
    }
    ::v-deep {
      .button-pay-type {
        &.v-item--active {
          background-color: @color-primary !important;
          color: #ffffff;
        }

      }
    }
    .button-pay-type {
      margin: 0 0 20px;
      &:last-child {
        margin-bottom: 0;
      }
      &:before {
        display: none;
      }
    }
  }

  .new-address-section {
    .label {
      display: block;
      font-size: 24px;
      line-height: 21px;
      margin-bottom: 25px;
    }

    .button-add {
      background-color: @color-primary !important;
      height: 94px;

      svg {
        width: 20px;
        height: 20px;
        margin-bottom: 12px;
      }
    }
  }

  .text-field {
    &.v-input--is-focused {
      ::v-deep {
        .v-input__slot {
          border: 2px solid #ff9500;
        }
      }
    }

    ::v-deep {
      .v-input__slot {
        height: 80px;
        background-color: @color-secondary;
        border-radius: 15px;

        input {
          font-size: 25px;
          line-height: 18px;
        }
      }
    }
  }

  .payment-modes {
    margin-bottom: 24px;
  }

  .payment-modes-hint {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: -12px 0 24px;
    font-size: 18px;
    line-height: 1.35;
    color: @color-btn-dark-grey;

    svg {
      flex-shrink: 0;
      .fill-svg(@color-primary);
    }
  }
  .card-section {
  }

  .cash-section {
    .label {
      font-size: 24px;
      line-height: 1;
      margin-bottom: 33px;
    }

    .amount-field {
      margin-bottom: 32px;

      .button-clear {
        svg {
          margin-right: 13px;
          .fill-svg(@color-error);
        }
      }
    }
  }

  .paid-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 50px 20px;

    .order-code {
      font-size: 36px;
      line-height: 1.1;
      font-weight: 500;
    }

    .date {
      font-size: 20px;
      margin-bottom: 20px;
    }

    .paid-status {
      color: #0033ff;
      font-size: 50px;
      font-weight: bold;
      margin-bottom: 30px;
    }

    .actions {
      margin-bottom: 40px;

      .button {
        padding-left: 30px;
        padding-right: 30px;

        &.red {
          background-color: #f44336 !important;
          color: #fff !important;
        }

        svg {
          margin-right: 15px;
          font-size: 18px;
        }
      }
    }

    .pay-desc {
      p {
        margin-bottom: 15px;
        line-height: 1.3;
      }
    }
  }
}
::v-deep {
  .cancel-order-dialog {
    background: #ffffff;
    padding: 95px 55px 72px;

    .dialog-title {
      font-size: 34px;
      margin-bottom: 30px;
    }

    .dialog-desc {
      margin-bottom: 70px;
    }

    .button {
      height: 80px;
      font-size: 15px;
      padding: 0 25px;
      border-radius: 10px;

      svg {
        margin-right: 5px;
      }
    }
  }
}
</style>
